import ClassNames from "classnames";
import { FunctionComponent } from "react";
import globalTranslations from "../../i18n/index.js";
import { Language } from "../../types/index.js";
import { getTranslations } from "../../utils/utils.js";

interface Props {
  isMenuOpen: boolean;
  languageId: Language;
  onClick: () => void;
}

const CircleHamburgerButton: FunctionComponent<Props> = ({
  isMenuOpen,
  languageId,
  onClick,
}) => {
  const i18n = getTranslations(languageId, globalTranslations);

  return (
    <button
      type="button"
      className={ClassNames("CircleHamburgerButton", {
        "CircleHamburgerButton--open": isMenuOpen,
      })}
      onClick={onClick}
      aria-label={isMenuOpen ? i18n.menu.close : i18n.menu.open}
    >
      <span className="CircleHamburgerButton__Inner">
        <span className="CircleHamburgerButton__Icon">
          <span className="CircleHamburgerButton__Line CircleHamburgerButton__Line1"></span>
          <span className="CircleHamburgerButton__Line CircleHamburgerButton__Line2"></span>
          <span className="CircleHamburgerButton__Line CircleHamburgerButton__Line3"></span>
          <span className="CircleHamburgerButton__Line CircleHamburgerButton__Line4"></span>
        </span>
      </span>
    </button>
  );
};

export default CircleHamburgerButton;
